import { onLCP, onINP, onCLS, onFCP, onTTFB } from "web-vitals";
import { API_BASE } from "@/lib/api";

const SID_KEY = "hv_sid";

function sessionId() {
  let id = sessionStorage.getItem(SID_KEY);
  if (!id) {
    id = Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem(SID_KEY, id);
  }
  return id;
}

const device = () => (window.innerWidth < 768 ? "mobile" : window.innerWidth < 1100 ? "tablet" : "desktop");
const route = () => window.location.pathname.replace(/\/[0-9a-f]{12,}/gi, "/:id").slice(0, 120) || "/";

let queue = [];
let timer = null;

function flush() {
  clearTimeout(timer);
  timer = null;
  if (!queue.length) return;
  const metrics = queue.splice(0, 20);
  fetch(`${API_BASE}/metrics/vitals`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      session_id: sessionId(), device: device(),
      connection: navigator.connection?.effectiveType || null, metrics,
    }),
    keepalive: true,
  }).catch(() => {});
}

function report(m) {
  const r = route();
  if (r.startsWith("/admin")) return;
  queue.push({ name: m.name, value: m.value, rating: m.rating, route: r });
  if (!timer) timer = setTimeout(flush, 5000);
}

export function initWebVitals() {
  [onLCP, onINP, onCLS, onFCP, onTTFB].forEach((fn) => fn(report));
  document.addEventListener("visibilitychange", () => document.visibilityState === "hidden" && flush());
  window.addEventListener("pagehide", flush);
}
